module.exports = __webpack_public_path__ + "img/mgh-kanazawa@2x.22707115.jpg";